import React, { useContext } from "react";
import { ShareContext } from "components/context/share/ShareContext";
import { getDecodedHtml } from "utils/getDecodedHtml";
import ImageX from "components/utility/images/ImageX";

export const ContentPageShareExplanationMobileModal = () => {
	const data = useContext(ShareContext);
	const { explanationData, isMobile, updateState, mobileTooltipFlag } = data;

	const closeMobileShareExplanation = () => {
		updateState({ mobileTooltipFlag: false });
	};
	const getShareExplantionContent = (contentList) => {
		let content = "";
		if (typeof contentList === "string") {
			return contentList;
		} else {
			contentList.forEach((el) => {
				content =
					content + `<p class='content-page-share-explanation-title'>${el.title}</p>${el.content}`;
			});
			return content;
		}
	};
	return (
		explanationData &&
		isMobile && (
			<div
				className={`content-page-share-explanation-mobile-modal animation-show ${
					mobileTooltipFlag ? "animation-top" : "animation-bottom"
				}`}
			>
				<div className="content-page-share-explanation-mobile">
					<button
						className="content-page-share-modal-close"
						onClick={() => {
							closeMobileShareExplanation();
						}}
						aria-label="close"
					>
						<ImageX />
					</button>
					<p className="content-page-share-explanation-mobile-title">
						{explanationData.mobileLabel}
					</p>
					<div
						className="content-page-share-explanation-mobile-content"
						dangerouslySetInnerHTML={{
							__html: getDecodedHtml(getShareExplantionContent(explanationData.description))
						}}
					></div>
				</div>
			</div>
		)
	);
};

export default {
	ContentPageShareExplanationMobileModal
};
